import { isAndroid } from 'react-device-detect';

import { useClientHasRendered } from '@domain/session/useClientHasRendered';

export const useIsAndroid = (): boolean => {
  const clientHasRendered = useClientHasRendered();
  return clientHasRendered && isAndroid;
};
